import { type GetBackProcedimentiParams } from '@framework/api-client/api/backoffice/schemas/getBackProcedimentiParams.ts';
import { type Procedimento } from '@framework/api-client/api/backoffice/schemas/procedimento.ts';
import { ColumnSortDirections } from '@framework/ui/components/table/TableColumnSort.tsx';
import { type TablePaginationConfig } from 'antd';
import { type SorterResult } from 'antd/es/table/interface';
import { useCallback } from 'react';

/**
 * Dobbiamo usare una funzione custom e non la usePaginationChange perché il DTO
 * è di BO e non è allineato al tipo di paginazione e ordinamenti usati FO.
 */
export function useDossierPaginationChange(
  query: GetBackProcedimentiParams,
  setQuery: (query: GetBackProcedimentiParams) => void,
) {
  const onChange = useCallback(
    (
      pagination: TablePaginationConfig,
      _: any,
      sorter: SorterResult<Procedimento> | Array<SorterResult<Procedimento>>,
    ) => {
      const sortBy = Array.isArray(sorter) ? sorter[0] : sorter;

      setQuery({
        ...query,
        page: pagination.current ? pagination.current : 0,
        pageSize: pagination.pageSize,
        sortBy: (sortBy.column?.sortDataIndex ??
          sortBy.field ??
          'DATA_ULTIMA_MODIFICA') as string,
        sortDirection:
          sortBy.order === 'ascend'
            ? ColumnSortDirections.ascend
            : ColumnSortDirections.descend,
      });
    },
    [query, setQuery],
  );

  return onChange;
}
